<div class="card">
  <div class="card-header bg-gradient-gray-dark text-orange">
    <h1>{{ucid}}  ::  {{lineName}}</h1>
  </div>
  <div class="card-body">

    <p-table [value]="billsOfLine" [tableStyle]="{'min-width': '60rem'}" [styleClass]="'p-datatable-sm'">
      <ng-template pTemplate="header">
        <tr>
          <th>Contract Status</th>
          <th>Current Balance</th>
          <th>Status Message</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-ticket>
        <tr>
          <td>{{ticket.contractStatus}}</td>
          <td>{{ticket.currentBalance}}</td>
          <td>{{ticket.statusMessage}}</td>

        </tr>
      </ng-template>
      <ng-template pTemplate="summary">
        <div class="flex align-items-center justify-content-between">
          In total there are {{billsOfLine ? billsOfLine.length : 0 }} tickets.
        </div>
      </ng-template>
    </p-table>
  </div>

</div>

